document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll(".team-name");
    const images = document.querySelectorAll(".team-image");
    let activeIndex = 0;

    buttons.forEach(button => {
        button.addEventListener("mouseover", function(event) {

            let teamIndex = parseInt(this.getAttribute("data-team"));
            if (teamIndex === activeIndex) return;

            // Remove active class from all buttons
            buttons.forEach(btn => btn.classList.remove("active"));

            // Add active class to clicked button
            this.classList.add("active");

            // Animate images
            images[activeIndex].classList.remove("active");
            images[activeIndex].classList.add("previous");

            images[teamIndex].classList.add("active");
            images[teamIndex].classList.remove("previous");

            activeIndex = teamIndex;
        });
    });
});

$(document).ready(function(){
$('.new-arrival-sec').each(function() {
  var $tabSection = $(this);
  $tabSection.find('.tab').on('click', function(evt) {
    evt.preventDefault();
    $tabSection.find('.tab').removeClass('active');
    $tabSection.find('.tab-content').removeClass('active');
    $(this).addClass('active');
    var target = $(this).data('toggles-target');
    if(target) {
      $tabSection.find(target).addClass('active');
    }
  });
});


  $('.new-arrival-sec-pro-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.6,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  $('.new-arrival-sec .tab').on('click', function () {
  $('.new-arrival-sec-pro-slider').slick('refresh');
});

    $('.custom-footer-middle h3').on('click', function () {
  $(this).next('.custom-footer-item ul, .addres-footer').toggle();
  $(this).toggleClass('active');
      
});

/*   setTimeout(() => {


  }, 4000);
 */

   


  $('.select-player-select-box-item label').click(function(){
  var pselectVal = $(this).text();
  const playerName = $(this)[0].dataset.playerName
  const playerNumber = $(this)[0].dataset.playerNumber
  const customEvent = new Event('change');

  $(this).addClass('active').siblings().removeClass('active'); 
  $(this).closest('.select-player-select-box').find('h2').text(pselectVal).next('input#CustomName')
  $('input#CustomName').val(playerName).trigger('change');
  $('input#CustomNumber').val(playerNumber).trigger('change');
  $('input#CustomerName').val(playerName).trigger('change');
  $('input#CustomerNumber').val(playerNumber).trigger('change');


  $(this).closest('.select-player-select-box-main').hide();
})

$('input#CustomerName').on('input',function(){
  const customerName = $(this).val()
  $('input#CustomName').val(customerName);
})

$('input#CustomerNumber').on('input',function(){
  let customerNumber = $(this).val()
  if(+customerNumber > 99) {
    customerNumber = customerNumber.slice(1)
  }

  $('input#CustomNumber').val(customerNumber);
})

$('.select-player-select-box h2').on('click', function() {
       $('.select-player-select-box-main').toggle() 
  })

  $('.player').on('click', function () {
    $('.select-player-select-box').css("display", "block");
    $('.select-personaliz').css("display", "none");
});
  $('.personalise').on('click', function () {
    $('.select-player-select-box').css("display", "none");
    $('.select-personaliz').css("display", "block");
});
   $('.pdp-none').on('click', function () {
    $('.select-player-select-box').css("display", "none");
    $('.select-personaliz').css("display", "none");
});

  $(".customize-check-box li").click(function () {
      $(".customize-check-box li").removeClass("active");
      $(this).addClass("active");
  });

   $(".readmore").click(function () {
      $(".product-detals").addClass("active");
      $(this).hide();
  });

  $(".pdp-none").click(function(e){
    e.preventDefault();
    $("#CustomName").val("")
    $("#CustomNumber").val("")
})

   $("ul.list-menu > li.mege-menu").hover(
        function () {
            $("body").addClass("menu-hover-active");
        },
        function () {
            $("body").removeClass("menu-hover-active");
        }
    );

  

// Function to initialize or destroy the Slick slider based on screen size
function handleSlickSlider() {
  if (window.matchMedia("(max-width: 550px)").matches) {
    if (!$('.edition--left').hasClass('slick-initialized')) {
      // Initialize the slider if it's not already initialized
      $('.edition--left').slick({
        infinite: false,
        slidesToShow: 1.7,
        arrows: true,
        dots: false,
        slidesToScroll: 1
      });
    }
  } else {
    if ($('.edition--left').hasClass('slick-initialized')) {
      // Destroy the slider if screen is wider than 550px
      $('.edition--left').slick('unslick');
    }
  }
}

// Call the function initially
handleSlickSlider();

// Listen for window resize events
$(window).resize(function() {
  handleSlickSlider();
});

// Function to initialize or destroy the sliders based on screen size
function handleSliders() {
  // First slider
  if (window.matchMedia("(max-width: 550px)").matches) {
    if (!$('.edition--left').hasClass('slick-initialized')) {
      // Initialize first slider if it's not already initialized
      $('.edition--left').slick({
        infinite: false,
        slidesToShow: 1.7,
        arrows: true,
        dots: false,
        slidesToScroll: 1
      });
    }

    if (!$('.shop-by-player-block').hasClass('slick-initialized')) {
      // Initialize second slider if it's not already initialized
      $('.shop-by-player-block').slick({
        infinite: false,
        slidesToShow: 2.2,
        arrows: true,
        dots: false,
        slidesToScroll: 1
      });
    }
  } else {
    if ($('.edition--left').hasClass('slick-initialized')) {
      // Destroy first slider if screen is wider than 550px
      $('.edition--left').slick('unslick');
    }

    if ($('.shop-by-player-block').hasClass('slick-initialized')) {
      // Destroy second slider if screen is wider than 550px
      $('.shop-by-player-block').slick('unslick');
    }
  }
}

// Call the function initially
handleSliders();

// Listen for window resize events
$(window).resize(function() {
  handleSliders();
});

  
})
$(document).on('click', '.header-mega-menu-header .tab', function(evtt) {
    //evtt.preventDefault();
    $('.header-mega-menu-header .tab').removeClass('active');
    $('.menu-drawer__navigation-container .tab-content').removeClass('active');
    $(this).addClass('active');
    var target = $(this).attr('data-toggles-target');
    $(target).addClass('active');
});

// setTimeout(function () {
//     $('.related-product-slider').slick({
//       dots: true,
//       infinite: false,
//       speed: 300,
//       slidesToShow: 4.2,
//       slidesToScroll: 4,
//       responsive: [
//         {
//           breakpoint: 1025,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 4,
//             infinite: false,
//             dots: true
//           }
//         },
//         {
//           breakpoint: 769,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2
//           }
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 1.6,
//             slidesToScroll: 1
//           }
//         }
//       ]
// });
// }, 4000); 
// Select the element to observe
const targetNode = document.querySelector('product-recommendations');

// Options for the observer (which mutations to observe)
const config = { attributes: true, attributeFilter: ['class'] };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      console.log('The class attribute was modified:', mutation.target.classList);
      // Perform actions based on the class change
      $('.related-product-slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4.2,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 4,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.6,
            slidesToScroll: 1
          }
        }
      ]
});
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

// To stop observing
// observer.disconnect();

   

